<form [formGroup]="form">
  <h5>Reset your Password</h5>
  <div class="form-part custom-text">Note: This procedure will not work if you have not yet changed the temporary password received by email.</div>
  <div class="form-part">
    <div class="custom-text">1. Get your password reset code</div>
    <label for="username" class="label">Email</label>
    <div class="flex-space-between">
      <input id="username" type="email" formControlName="username" placeholder="john.doe@example.com"
             class="input email-input">
      <button class="vlr-primary-btn code-button" (click)="forgotPassword()" [disabled]="!form.get('username')?.valid">
        Send code
      </button>
    </div>
    <div class="custom-text message">
      {{ codeMessage }}
    </div>
  </div>

  <div class="form-part">
    <div class="custom-text">2. Enter the code</div>
    <div>
      <label for="code" class="label">Code</label>
      <input id="code" type="text" formControlName="code"
             class="input" autocomplete="off">
    </div>
  </div>

  <div class="form-part">
    <div class="custom-text">
      3. Choose a new password:
      <ul>
        <li>Require at least 8 characters but fewer than 99 characters</li>
        <li>Require numbers</li>
        <li>
          Require a special character from this set:
          <br>^ $ * . [ ] &#123; &#125; ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ ` = + -
        </li>
        <li>Require uppercase letters</li>
        <li>Require lowercase letters</li>
      </ul>
    </div>
    <div class="form-part-2">
      <label for="newPassword" class="label">New password</label>
      <input id="newPassword" type="password" formControlName="password"
             class="input" autocomplete="off">
      <label for="confirmPassword" class="label">Confirm password</label>
      <input id="confirmPassword" type="password" formControlName="confirmPassword"
             class="input" autocomplete="off">
    </div>
    <div class="error-message message">
      {{ submitErrorMessage }}
    </div>
  </div>

  <div class="flex-space-between">
    <div>
      <span *ngIf="succeed">Succeed, you will be redirected in few seconds...</span>
    </div>
    <button (click)="forgotPasswordSubmit()" class="vlr-primary-btn" [disabled]="!form.valid || succeed">
      Change password
    </button>
  </div>
</form>
